import {NodeChange, EdgeChange} from 'reactflow';

import {makeReactContext} from 'lib/makeReactContext';
import {
  CustomMappingData,
  TransitionSource,
} from 'processes/settings/graph-builder-flowchart-config/horizontal-flowchart/processFlowchartConfigEditorConstants';
import {FlowchartNode} from 'processes/settings/graph-builder-flowchart-config/horizontal-flowchart/processFlowchartConfigEditorNodeTypes';

import {ProcessTaskSchemaGraphQL} from '../../../../../../graphql-fragments/processes/schemas/__generated/ProcessTaskSchemaGraphQL';
import {NodeSidepanelBaseData} from './nodeUtils';

export interface NodeDetailsSidepanelContextValue extends NodeSidepanelBaseData {
  transitionSourceByNodeIdPair: Record<string, TransitionSource>;
  onChangeTransitionSource: (edgeId: string, newTransitionSource: TransitionSource) => void;
  onChangeFlowchart: ({
    nodeChanges,
    edgeChanges,
  }: {
    nodeChanges: Array<NodeChange>;
    edgeChanges: Array<EdgeChange>;
  }) => void;
  customMappingDataByEdgeId: Record<string, CustomMappingData>;
  onChangeCustomMappingData: (edgeId: string, newCustomMappingData: CustomMappingData) => void;
  refetchFlowchartConfig?: () => void;
}

/** Context to provide node details sidepanel content with shared data and callbacks
 *
 * This contains all workflows-specific content that an application team wouldn't need to build
 * their sidepanels. If they do end up needing some of this content, they can use the context to access.
 */
export const NodeDetailsSidepanelContext = makeReactContext<NodeDetailsSidepanelContextValue>(
  () => ({
    selectedNode: null as unknown as FlowchartNode,
    interactiveFlowchart: {nodes: [], edges: []},
    allSchemasById: {},
    flowchartTaskSchema: null as unknown as ProcessTaskSchemaGraphQL,
    customMappingDataByEdgeId: {},
    onChangeCustomMappingData: () => {},
    transitionSourceByNodeIdPair: {},
    onChangeTransitionSource: () => {},
    onChangeFlowchart: () => {},
    refetchFlowchartConfig: undefined,
  }),
  'NodeDetailsSidepanelContext'
);
